import { Flex, Text } from '@chakra-ui/react'

const Optimizing = () => {
  return (
    <Flex
      w="100%"
      mt={{
        base: '40px',
        sm: '50px'
      }}
      flexDir="column"
      alignItems="center"
      justifyContent="center"
    >
      <Text
        textStyle="oralcareOptimizingTitle"
        textAlign="left"
        textTransform="uppercase"
        w={{
          base: '90%',
          sm: '81%'
        }}
        color="white"
        mt={{
          base: '1px',
          sm: '10px',
          md: '10px',
          lg: '10px'
        }}
      >
        Optimizing Oral Hygiene: Beyond Brushing
      </Text>
      <Text
        textStyle="oralcareOptimizingContent"
        textAlign="justify"
        fontWeight={400}
        w={{
          base: '90%',
          sm: '81%'
        }}
        color="white"
        mt={{
          base: '1px',
          sm: '10px',
          md: '10px',
          lg: '10px'
        }}
      >
        Even diligent brushing leaves bacteria thriving amidst the remnants in
        your mouth. It's imperative to thoroughly eliminate debris post-brushing
        to curb bacterial growth effectively.
      </Text>
    </Flex>
  )
}

export default Optimizing
